import { baseUrl } from "./Api";

const PRODUCTION_API_HOSTS = ["api.ehealthmatrix.com"];

const UNLOCK_PASSWORD = "Admiiiin@785536";

const LOCK_SCREEN_MODE = "detach";

const HIDE_STORAGE_WHILE_LOCKED = true;

const DEBUG = true;

const CLEAR_CONSOLE_ON_PROMPT = true;

const RELOCK_WHEN_DEVTOOLS_CLOSED = true;

const UNLOCK_GRACE_MS = 15000;

const BLOCK_RIGHT_CLICK = false;

const DETECT_DEVTOOLS_OPEN = true;
const DETECT_INTERVAL_MS = 500;
const WIDTH_THRESHOLD = 200;
const HEIGHT_THRESHOLD = 260;
const BASELINE_MARGIN = 120;

const BLOCK_SAVE_SHORTCUT = true;

const LEGACY_SESSION_KEY = "__ehm_inspect_unlocked__";

const hostOf = (url = "") => {
  try {
    return new URL(url, window.location.origin).hostname.toLowerCase();
  } catch (e) {
    return "";
  }
};

export const isProductionApi = PRODUCTION_API_HOSTS.includes(hostOf(baseUrl));

function isPasswordCorrect(rawValue) {
  const typed = (rawValue || "").trim();
  const ok = typed === UNLOCK_PASSWORD;
  if (DEBUG) console.log("[guard] typed length:", typed.length, "match:", ok);
  return ok;
}

let storageBackup = null;

function snapshot(store) {
  const out = {};
  for (let i = 0; i < store.length; i += 1) {
    const key = store.key(i);
    if (key !== null) out[key] = store.getItem(key);
  }
  return out;
}

function writeBack(store, data) {
  Object.keys(data).forEach((key) => {
    try {
      store.setItem(key, data[key]);
    } catch (e) {}
  });
}

function hideStorage() {
  if (!HIDE_STORAGE_WHILE_LOCKED || storageBackup) return;
  try {
    storageBackup = {
      local: snapshot(window.localStorage),
      session: snapshot(window.sessionStorage),
    };
    window.localStorage.clear();
    window.sessionStorage.clear();
    if (DEBUG) {
      console.log(
        "[guard] storage hidden:",
        Object.keys(storageBackup.local).length,
        "local,",
        Object.keys(storageBackup.session).length,
        "session",
      );
    }
  } catch (e) {
    if (storageBackup) restoreStorage();
    if (DEBUG) console.log("[guard] storage hide failed:", e);
  }
}

function restoreStorage() {
  if (!storageBackup) return;
  const backup = storageBackup;
  storageBackup = null;
  try {
    writeBack(window.localStorage, backup.local);
    writeBack(window.sessionStorage, backup.session);
    if (DEBUG) console.log("[guard] storage restored");
  } catch (e) {
    if (DEBUG) console.log("[guard] storage restore failed:", e);
  }
}

const onPageLeaving = () => restoreStorage();

let detachedNodes = [];
let appHidden = false;

function hideAppContent(overlay) {
  if (appHidden || LOCK_SCREEN_MODE === "none") return;

  Array.from(document.body.childNodes).forEach((node) => {
    if (node === overlay) return;
    if (node.nodeType === Node.COMMENT_NODE) return;

    if (LOCK_SCREEN_MODE === "detach") {
      detachedNodes.push({ node, hiddenStyle: null });
      document.body.removeChild(node);
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      detachedNodes.push({ node, hiddenStyle: node.style.display });
      node.style.display = "none";
    }
  });

  appHidden = true;
  if (DEBUG) console.log("[guard] app content hidden:", detachedNodes.length);
}

function restoreAppContent(overlay) {
  if (!appHidden) return;

  detachedNodes.forEach(({ node, hiddenStyle }) => {
    if (LOCK_SCREEN_MODE === "detach") {
      if (overlay && overlay.parentNode === document.body) {
        document.body.insertBefore(node, overlay);
      } else {
        document.body.appendChild(node);
      }
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      node.style.display = hiddenStyle || "";
    }
  });

  detachedNodes = [];
  appHidden = false;
  if (DEBUG) console.log("[guard] app content restored");
}

const EYE_SVG =
  '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
  '<path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>';

const EYE_OFF_SVG =
  '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
  '<path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/>' +
  '<line x1="1" y1="1" x2="23" y2="23"/></svg>';

let promptOpen = false;
let activePrompt = null;

function openPasswordPrompt(onSuccess, mode = "shortcut") {
  if (promptOpen) return;
  promptOpen = true;

  if (CLEAR_CONSOLE_ON_PROMPT) {
    try {
      console.clear();
    } catch (e) {}
  }

  const masked = mode === "detect";

  const overlay = document.createElement("div");
  overlay.setAttribute("role", "dialog");
  overlay.setAttribute("aria-modal", "true");
  overlay.style.cssText = [
    "position:fixed",
    "inset:0",
    "z-index:2147483647",
    "display:flex",
    "align-items:center",
    "justify-content:center",
    masked ? "background:#0f172a" : "background:rgba(15,23,42,0.55)",
    "font-family:sans-serif",
  ].join(";");

  const card = document.createElement("div");
  card.style.cssText = [
    "width:330px",
    "max-width:90vw",
    "background:#ffffff",
    "border-radius:10px",
    "padding:22px",
    "box-shadow:0 18px 45px rgba(15,23,42,0.35)",
  ].join(";");

  const heading = document.createElement("div");
  heading.textContent = "Developer access";
  heading.style.cssText =
    "font-size:16px;font-weight:600;color:#0f172a;margin-bottom:6px";

  const note = document.createElement("div");
  note.textContent = masked
    ? "Developer tools are open. Enter the access password to continue using the app."
    : "Developer tools are locked. Enter the access password.";
  note.style.cssText =
    "font-size:13px;color:#64748b;line-height:1.45;margin-bottom:14px";

  const field = document.createElement("div");
  field.style.cssText = "position:relative";

  const input = document.createElement("input");
  input.type = "password";
  input.name = "ehm-dev-access";
  input.autocomplete = "new-password";
  input.spellcheck = false;
  input.style.cssText = [
    "width:100%",
    "box-sizing:border-box",
    "padding:9px 40px 9px 11px",
    "border:1px solid #cbd5e1",
    "border-radius:6px",
    "font-size:14px",
    "outline:none",
  ].join(";");

  const eyeBtn = document.createElement("button");
  eyeBtn.type = "button";
  eyeBtn.setAttribute("aria-label", "Show password");
  eyeBtn.innerHTML = EYE_SVG;
  eyeBtn.style.cssText = [
    "position:absolute",
    "top:50%",
    "right:6px",
    "transform:translateY(-50%)",
    "display:flex",
    "align-items:center",
    "justify-content:center",
    "width:30px",
    "height:30px",
    "padding:0",
    "border:none",
    "background:transparent",
    "color:#64748b",
    "cursor:pointer",
  ].join(";");

  eyeBtn.addEventListener("click", () => {
    const show = input.type === "password";
    input.type = show ? "text" : "password";
    eyeBtn.innerHTML = show ? EYE_OFF_SVG : EYE_SVG;
    eyeBtn.setAttribute("aria-label", show ? "Hide password" : "Show password");
    input.focus();
  });

  field.appendChild(input);
  field.appendChild(eyeBtn);

  const error = document.createElement("div");
  error.style.cssText =
    "font-size:12px;color:#b91c1c;min-height:16px;margin-top:7px";

  const row = document.createElement("div");
  row.style.cssText =
    "display:flex;gap:8px;justify-content:flex-end;margin-top:14px";

  const cancelBtn = document.createElement("button");
  cancelBtn.type = "button";
  cancelBtn.textContent = "Cancel";
  cancelBtn.style.cssText = [
    "padding:8px 14px",
    "border:1px solid #cbd5e1",
    "background:#fff",
    "color:#334155",
    "border-radius:6px",
    "font-size:13px",
    "cursor:pointer",
  ].join(";");

  const okBtn = document.createElement("button");
  okBtn.type = "button";
  okBtn.textContent = "Unlock";
  okBtn.style.cssText = [
    "padding:8px 14px",
    "border:1px solid #1d4ed8",
    "background:#1d4ed8",
    "color:#fff",
    "border-radius:6px",
    "font-size:13px",
    "cursor:pointer",
  ].join(";");

  const close = () => {
    promptOpen = false;
    activePrompt = null;
    document.removeEventListener("keydown", onOverlayKey, true);
    if (masked) {
      restoreStorage();
      restoreAppContent(overlay);
    }
    overlay.remove();
  };

  const submit = () => {
    if (!card.contains(field)) return;
    if (!isPasswordCorrect(input.value)) {
      error.textContent = "Password is not correct.";
      input.value = "";
      input.focus();
      return;
    }

    onSuccess();

    if (masked) {
      close();
      return;
    }

    heading.textContent = "Unlocked";
    note.textContent =
      "Press F12 again to open developer tools. Closing them will lock access again.";
    field.remove();
    error.remove();
    if (card.contains(cancelBtn)) cancelBtn.remove();
    okBtn.textContent = "Close";
    okBtn.onclick = close;
  };

  const onOverlayKey = (e) => {
    if (!overlay.contains(e.target)) return;
    e.stopPropagation();
    if (e.key === "Enter") submit();
    if (e.key === "Escape" && !masked) close();
  };

  cancelBtn.addEventListener("click", close);
  okBtn.addEventListener("click", submit);
  document.addEventListener("keydown", onOverlayKey, true);

  if (!masked) row.appendChild(cancelBtn);
  row.appendChild(okBtn);
  card.appendChild(heading);
  card.appendChild(note);
  card.appendChild(field);
  card.appendChild(error);
  card.appendChild(row);
  overlay.appendChild(card);
  document.body.appendChild(overlay);

  if (masked) {
    hideStorage();
    hideAppContent(overlay);
  }

  input.focus();
  activePrompt = { close, mode };
}

let baseWidthGap = Infinity;
let baseHeightGap = Infinity;

const currentGaps = () => ({
  w: window.outerWidth - window.innerWidth,
  h: window.outerHeight - window.innerHeight,
});

const devToolsLikelyOpen = () => {
  const { w, h } = currentGaps();

  const overFixed = w > WIDTH_THRESHOLD || h > HEIGHT_THRESHOLD;
  const overBaseline =
    w > baseWidthGap + BASELINE_MARGIN || h > baseHeightGap + BASELINE_MARGIN;
  const open = overFixed || overBaseline;

  if (!open) {
    baseWidthGap = Math.min(baseWidthGap, w);
    baseHeightGap = Math.min(baseHeightGap, h);
  }

  return open;
};

let installed = false;
let unlocked = false;
let unlockedAt = 0;
let sawDevToolsOpen = false;
let detectTimer = null;

const isBlockedCombo = (e) => {
  const key = (e.key || "").toLowerCase();
  const mod = e.ctrlKey || e.metaKey;

  if (key === "f12") return true; // F12
  if (mod && e.shiftKey && ["i", "j", "c"].includes(key)) return true;
  if (mod && e.altKey && ["i", "j", "c"].includes(key)) return true;
  if (mod && !e.shiftKey && !e.altKey && key === "u") return true;
  if (BLOCK_SAVE_SHORTCUT && mod && key === "s") return true;
  return false;
};

const onContextMenu = (e) => {
  if (unlocked || !BLOCK_RIGHT_CLICK) return;
  e.preventDefault();
};

const onKeyDown = (e) => {
  if (unlocked) return;
  if (!isBlockedCombo(e)) return;
  e.preventDefault();
  e.stopPropagation();
  openPasswordPrompt(unlock, "shortcut");
};

function unlock() {
  unlocked = true;
  unlockedAt = Date.now();
  sawDevToolsOpen = devToolsLikelyOpen();
  if (DEBUG) console.log("[guard] unlocked, devtools open:", sawDevToolsOpen);
}

function relock() {
  unlocked = false;
  unlockedAt = 0;
  sawDevToolsOpen = false;
  if (DEBUG) console.log("[guard] relocked");
}

const checkDevTools = () => {
  const open = devToolsLikelyOpen();

  if (!open) {
    if (unlocked && RELOCK_WHEN_DEVTOOLS_CLOSED) {
      const graceOver = Date.now() - unlockedAt > UNLOCK_GRACE_MS;
      if (sawDevToolsOpen || graceOver) relock();
    }
    if (activePrompt && activePrompt.mode === "detect") activePrompt.close();
    return;
  }

  if (unlocked) {
    sawDevToolsOpen = true;
    return;
  }

  if (!promptOpen) openPasswordPrompt(unlock, "detect");
};

export function installDevToolsGuard() {
  if (installed || typeof window === "undefined") return;
  if (!isProductionApi) {
    if (DEBUG) console.log("[guard] not a production API host, guard off");
    return;
  }
  installed = true;
  if (DEBUG) console.log("[guard] installed");

  try {
    window.sessionStorage.removeItem(LEGACY_SESSION_KEY);
  } catch (e) {}

  document.addEventListener("contextmenu", onContextMenu, true);
  document.addEventListener("keydown", onKeyDown, true);

  window.addEventListener("beforeunload", onPageLeaving);
  window.addEventListener("pagehide", onPageLeaving);

  if (DETECT_DEVTOOLS_OPEN) {
    detectTimer = setInterval(checkDevTools, DETECT_INTERVAL_MS);
    window.addEventListener("resize", checkDevTools);
  }

  if (DEBUG) {
    window.__guard = () => ({
      unlocked,
      promptOpen,
      promptMode: activePrompt && activePrompt.mode,
      appHidden,
      detachedCount: detachedNodes.length,
      storageHidden: !!storageBackup,
      sawDevToolsOpen,
      gaps: currentGaps(),
      baseline: { w: baseWidthGap, h: baseHeightGap },
      detectedOpen: devToolsLikelyOpen(),
    });
  }
}

export function removeDevToolsGuard() {
  if (!installed) return;
  restoreStorage();
  document.removeEventListener("contextmenu", onContextMenu, true);
  document.removeEventListener("keydown", onKeyDown, true);
  window.removeEventListener("beforeunload", onPageLeaving);
  window.removeEventListener("pagehide", onPageLeaving);
  window.removeEventListener("resize", checkDevTools);
  if (detectTimer) {
    clearInterval(detectTimer);
    detectTimer = null;
  }
  installed = false;
}

export default installDevToolsGuard;
